import { DatePipe } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import { Observable } from "rxjs/Observable";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import { SalesInvoiceService } from "../../../services/salesinvoice.service";

@Component({
  selector: "addedit-invoice-tab",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "convertShirtTypes.html",
})
export class convertShirtTypes implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input() active = false;
  @Input() _params: any;
  @Output() tabUpdateEvent = new EventEmitter();

  invoicedata: any = {
    barcode: "",
    to_type: "",
    from_type: "",
    remarks: "",
  };
  typeCheck: boolean;

  isLoadMask: Promise<any>;
  execApi: boolean = true;
  ConvertList = ["FRESH", "DAMAGE", "SET WISE", "SIZE WISE"];
  mode = "Add";
  saveEvent: any;
  beltNoList: any;
  designList: any;
  totshirts: number = 0;
  styles: any;
  samp_id: any;
  updatelist: any;
  styleNoList: any;
  typeList: any;

  @Input() set params(val: any[]) {
    this._params = val;
    this.mode = val["mode"];
    let updateData = Object.assign({}, val["data"]);
    this.saveEvent = val["data"].tabevent;
    this.updatelist = updateData;
    if (this.mode == "View") {
      this.loadupdatelist();
      this.invoicedata.from_type = this.updatelist.from_type;
      this.invoicedata.to_type = this.updatelist.to_type;
      this.invoicedata.remarks = this.updatelist.remarks;
      this.totshirts = this.updatelist.totpcs;
      // this.loadupdatelist();
    }
  }

  get params(): any[] {
    return this._params;
  }

  sample_no: any;

  page_id: string = Math.random().toString(36).substr(2, 9) + "_";
  isLoading: boolean = false;
  barcodeType_check: boolean = false;
  companyList$ = [];
  sampleno: any;
  collarList: any;
  partyList: any = [];
  finyearList = [];
  list: any;
  designnoList = [];

  companyList: Observable<any[]>;
  shadeList = [];
  colorList: any = [];
  shirtList: any = [];
  itemgroupList = [];
  sampleList = [];
  sample: any = {};

  groupData: any = [];
  data: any = {};
  sampledata: any = {
    sample_type: "",
  };
  groupList: any = [];
  categoryList: any;
  type: any;

  constructor(
    public store: Store<fromRootStore.State>,
    public toasterService: ToasterService,
    private salesinvservice: SalesInvoiceService,
    public datePipe: DatePipe
  ) {
    this.data = {
      invoiceList: [],
    };
  }
  hotkeys(event) {
    if (this.active) {
    }
  }

  trackByIndex(index: number, value: any) {
    return index;
  }

  ngOnInit(): void {}

  selectConvertList(type) {
    if (type == "FRESH") {
      this.invoicedata.to_type = "DAMAGE";
    } else if (type == "DAMAGE") {
      this.invoicedata.to_type = "FRESH";
    } else if (type == "SET WISE") {
      this.invoicedata.to_type = "SIZE WISE";
    } else if (type == "SIZE WISE") {
      this.invoicedata.to_type = "SET WISE";
    }
  }
  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      setTimeout(() => {
        $("#" + nextEl).focus();
      }, 100);
    }
  }
  checkBarcode(code) {
    if (this.invoicedata.from_type && this.invoicedata.from_type != '') {
      if (code.length == 7) {
        if (this.execApi) {
          this.execApi = false;
          let params = {
            barcode: code,
          };
          for (let i = 0; i < this.data.invoiceList.length; i++) {
            code = parseInt(code);
            this.data.invoiceList[i].barcode = parseInt(
              this.data.invoiceList[i].barcode
            );
            if (this.data.invoiceList[i].barcode == code) {
              setTimeout(() => {
                this.invoicedata.barcode = "";
                $("#code").focus();
              }, 500);

              swal({
                title: "Barcode Already Exists",
                timer: 1000,
                type: "warning",
                showCancelButton: false,
                showConfirmButton: false,
              });
              this.execApi = true;
              return;
            }
          }

          this.salesinvservice
            .checkConvertShirtTypesBarcode(params)
            .then((res: any) => {
              if (res.data.length == 0) {
                //   swal("Selected Design is invalid!");
                swal({
                  title: "Selected Design is invalid",
                  type: "warning",
                  showCancelButton: false,
                  showConfirmButton: false,
                  timer: 1000,
                });
                let invalidData = {
                  barcode: code,
                  type: "invoice",
                };
                this.invoicedata.barcode = "";
                this.execApi = true;
                return;
              }
              let row = Object.assign(
                {
                  f36: 0,
                  f38: 0,
                  f40: 0,
                  f42: 0,
                  f44: 0,
                  f46: 0,
                  h36: 0,
                  h38: 0,
                  h40: 0,
                  h42: 0,
                  h44: 0,
                  h46: 0,
                  df36: 0,
                  df38: 0,
                  df40: 0,
                  df42: 0,
                  df44: 0,
                  df46: 0,
                  dh36: 0,
                  dh38: 0,
                  dh40: 0,
                  dh42: 0,
                  dh44: 0,
                  dh46: 0,
                  barcode_type: "",
                },
                res.data
              );

              if (
                row.barcode_type == null ||
                row.barcode_type == "SIZE WISE" ||
                row.barcode_type == "SET WISE"
              ) {
                if (
                  this.invoicedata.from_type === "SET WISE" &&
                  (row.barcode_type == null || row.barcode_type == "SET WISE")
                ) {
                  this.barcodeType_check = true;
                } else if (
                  this.invoicedata.from_type === "SIZE WISE" &&
                  row.barcode_type == "SIZE WISE"
                ) {
                  this.barcodeType_check = true;
                } else {
                  swal({
                    title: "Invalid",
                    text: "PLEASE SCAN " + this.invoicedata.from_type + " TYPE...",
                    timer: 2000,
                    type: "warning"
                  });
                  this.barcodeType_check = false;
                  this.invoicedata.barcode = "";
                  $("#barcode").focus();
                }
              }

              if (row.type == "FRESH") {
                row["d" + row.size.toLowerCase()] = 1;
              } else if (row.type == "DAMAGE") {
                row.size = row.size.substr(1);
                row[row.size.toLowerCase()] = 1;
                row.size = "D" + row.size;
              }

              this.checkDamageFresh(row.size);
              if (
                this.typeCheck ||
                (this.invoicedata.from_type === "SET WISE" &&
                  this.barcodeType_check) ||
                (this.invoicedata.from_type === "SIZE WISE" &&
                  this.barcodeType_check)
              ) {
                this.totshirts++;
                this.data.invoiceList.push(row);
                var bottom = document.querySelector("#salesTbody");
                setTimeout(() => {
                  bottom.scrollTop = bottom.scrollHeight;
                }, 300);
              } else {
                swal({
                  title: "Invalid",
                  text: "PLEASE SCAN " + this.invoicedata.from_type + " TYPE...",
                  timer: 2000,
                  type: "warning",
                });
                $("#barcode").focus();
              }
              this.execApi = true;
              this.invoicedata.barcode = "";
            });
        }
      } 
    }else {
      this.invoicedata.barcode = "";
      swal({
        title: "Invalid",
        text: "PLEASE SELECT FROM TYPE",
        timer: 2000
      });
    }
  }

  checkDamageFresh(type) {
    var res = type.split("");
    this.typeCheck = false;

    if (this.invoicedata.from_type == "FRESH") {
      if (res[0] != "D") {
        this.typeCheck = true;
      }
    } else {
      if (res[0] == "D") {
        this.typeCheck = true;
      }
    }

    return this.typeCheck;
  }
  loadupdatelist() {
    let params = {
      change_id: this.updatelist.change_id,
    };
    this.salesinvservice.loadupdatelist(params).then((res: any) => {
      if (res.data.length > 0) {
        this.data.invoiceList = res.data;
        // this.totshirts = res.data.length;
      }
    });
  }
  saveConvertType(): void {
    if (this.invoicedata.remarks == "") {
      swal("Make sure that the remarks entered");
    } else {
      let params: any = Object.assign({}, this.invoicedata);
      params["totshirts"] = this.totshirts;
      params["convertList"] = JSON.stringify(this.data.invoiceList);

      let that = this;

      swal({
        title: "Are you sure to convert?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, convert it!",
        cancelButtonText: "No, want to change",
      }).then(function () {
        that.isLoadMask = that.salesinvservice
          .saveConvertType(params)
          .then(function (res: any) {
            if (res) {
              that.data = {
                invoiceList: [],
              };
              that.isLoading = false;
              if (that.saveEvent) {
                that.saveEvent.emit();
              }
              that.invoicedata.from_type = "";
              that.invoicedata.to_type = "";
              that.invoicedata.remarks = "";
              that.invoicedata.barcode = "";
              that.totshirts = 0;
              that.toasterService.pop({
                bodyOutputType: 1,
                type: "success",
                title: "SUCCESS",
                body: res.message,
              });
            }
            let tabObj = {
              action: "CloseTab",
              params: {},
            };

            that.tabUpdateEvent.emit(tabObj);
          })
          .catch(function (error: any) {
            let res = JSON.parse(error._body);
            swal("ERROR", res.message, "error");
          });
      });
    }
  }

  onGoToNextFld($event, fld, ind) {
    let nxtInd = ind,
      shirt_design_no = this.groupList[ind]["shirt_design_no"],
      color = this.groupList[ind]["color"],
      shade = this.groupList[ind]["shade"],
      size = this.groupList[ind]["size"],
      slv = this.groupList[ind]["slv"],
      //  width = this.data.designList[ind]['width'],
      //        pcs = this.groupList[ind]['pcs'],
      mrp = this.groupList[ind]["mrp"],
      rate = this.groupList[ind]["rate"],
      amount = this.groupList[ind]["amount"];

    let nxtRow = $("#row-" + ind).next("tr");

    this.groupList.push({
      sample_no: "",
      shirt_design_no: "",
      color: "",
      shade: "",
      size: "",
      slv: "",
      //            pcs: '',
      rate: "",
      mrp: "",
      amount: "",
    });
    this.groupList[ind].samp_id = this.groupList[0].samp_id;
    $("#" + this.page_id + "sample_no" + "-" + nxtInd).focus();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      $("#" + "ConvertListFromType").focus();
    }, 100);
  }

  // onEnterKeyPressed() {
  //   $("#" + "sample_no-0").focus();
  // }

  onGoToUpAndDown($event, fld, arrow, ind) {
    //
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }
    if (arrow == "up") ind--;
    else ind++;

    if ($("#" + this.page_id + fld + "-" + ind).length > 0) {
      $("#" + this.page_id + fld + "-" + ind).focus();
    }
  }

  ngOnDestroy() {}
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/master/convertShirtTypes/convertShirtTypes.ts